import type { BannerSeverity } from "@/lib/ghost";

export const SEVERITY_STYLES: Record<BannerSeverity, string> = {
  info: "bg-b3-blue-50/75 text-b3-blue-900 border-b3-blue-200/60 backdrop-blur-md backdrop-saturate-150 dark:bg-b3-blue-950/70 dark:text-b3-blue-100 dark:border-b3-blue-800/60",
  warn: "bg-amber-50/75 text-amber-900 border-amber-200/60 backdrop-blur-md backdrop-saturate-150 dark:bg-amber-950/70 dark:text-amber-100 dark:border-amber-800/60",
  critical:
    "bg-red-50/75 text-red-900 border-red-200/60 backdrop-blur-md backdrop-saturate-150 dark:bg-red-950/70 dark:text-red-100 dark:border-red-800/60",
};

export const SEVERITY_DOT: Record<BannerSeverity, string> = {
  info: "bg-b3-blue-500",
  warn: "bg-amber-500",
  critical: "bg-red-500",
};

export const SEVERITY_LABEL: Record<BannerSeverity, string> = {
  info: "Notice",
  warn: "Heads up",
  critical: "Incident",
};
